import React from 'react'
import { Link } from '@inertiajs/react'

export default function Breadcrumb({ items }) {
  return (
    <nav className="mb-4 text-sm flex items-center gap-2">
      {items.map((item, index) => (
        <span key={item.href || index} className="flex items-center gap-2">
          {item.href ? (
            <Link href={item.href} className="link-subtle flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-500">{item.label}</span>
          )}
          {index < items.length - 1 && <span className="text-gray-300">/</span>}
        </span>
      ))}
    </nav>
  )
}
